export const enum TriggerHoldUntilReplyRuleType {
  SMS = 'ReceivedAnSMSRule',
  WHATSAPP = 'ReceivedWhatsAppRule',
}

export const enum TriggerHoldUntilReplyRuleValue {
  SMS = 'SMS',
  WHATSAPP = 'WhatsApp',
}
